import { JsonProperty } from '../../../models/utilities/json-property';
import { LocalTimeRead } from '../../../models/utilities/local-time-read';
import { PickupStatus } from '../enums/pickup-status';

export class PickupSummary {

    public id : number = 0;

    public status : PickupStatus = PickupStatus.Cancelled;
    
    public dealerId : string = '';
    
    public dealerName : string = '';
    
    public serviceCenterId : string = '';
    
    @JsonProperty({ toClass : LocalTimeRead })
    public pickupTime : LocalTimeRead = new LocalTimeRead();
    
    public amount : number = 0.0;

    // UI Helper Props
    public hasPendingAction : boolean = false;

}
